module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FIRE_ELEMENTAL_STYLE.75b36c98.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FIRE_ELEMENTAL_STYLE.png
// module id = 1283
// module chunks = 16